module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "场次",
      "value": _vm.row.station_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "时间",
      "value": _vm.row.station.startdate + '至' + _vm.row.station.enddate
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "地点",
      "value": _vm.row.station.province + '  ' + _vm.row.station.city + ' ' + _vm.row.station.county
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goFiles(1)
      }
    }
  }, [_vm._v("培训通知下载")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goFiles(2)
      }
    }
  }, [_vm._v("导师团")])], 1), _vm._v(" "), (_vm.row.learn_erweima) ? _c('div', {
    staticClass: "order-success"
  }, [(_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码进入小程序,在线学习")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.row.learn_erweima
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-success"
  }, [(_vm.row.erweiimg.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码加工作人员好友，进入培训微信群")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{name:'HuiyiApplyList'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("我的报名记录")])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("【重要】请仔细阅读下列说明")]), _vm._v(" "), _c('p', [_vm._v("1、报名成功后，请务必添加下方培训专属群！")]), _vm._v(" "), _c('p', [_vm._v("加群方式：群二维码截图-打开微信-扫一扫-相册-选择保存的群二维码图片即可")]), _vm._v(" "), _c('p', [_vm._v("2、本次培训含有线上培训内容，啦啦之星平台为指定培训课程平台，请用微信扫描下课程兑换码（本码仅限观看课程《全国啦啦操委员会新周期培训课程》，并非啦啦之星VIP年费会员），方可开始学习；注意：请在有效期内兑换，请用本人微信扫码兑换，一人一码，任何转借、外发，恕不再补；")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a2ed23c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormSuccess.vue
// module id = 1227
// module chunks = 0